import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      d="M7.947 3.904c.263 0 .516.102.701.284.186.182.29.428.29.685V6.85h1.822c.272 0 .534.102.726.283a.94.94 0 0 1 .301.684.94.94 0 0 1-.3.685 1.06 1.06 0 0 1-.727.283H8.938v12.563a.96.96 0 0 1-.29.686 1 1 0 0 1-.7.284H5.964c-.526 0-1.03.204-1.402.567-.372.364-.58.857-.58 1.37 0 .515.208 1.008.58 1.372.371.363.876.567 1.402.567h4.548v.004h.247c.272 0 .534.102.726.283a.94.94 0 0 1 .301.685.94.94 0 0 1-.3.683 1.06 1.06 0 0 1-.727.284H5.965a4 4 0 0 1-2.804-1.135A3.84 3.84 0 0 1 2 24.257V7.78c0-1.028.418-2.014 1.161-2.741a4 4 0 0 1 2.804-1.136zM19.19 26.199c.272 0 .534.102.726.283a.94.94 0 0 1 .3.685.94.94 0 0 1-.3.683 1.06 1.06 0 0 1-.726.284H15.08a1.06 1.06 0 0 1-.726-.284.94.94 0 0 1-.301-.683c0-.257.108-.504.3-.685a1.06 1.06 0 0 1 .727-.283zm9.615-2.902c.272 0 .533.102.725.283a.94.94 0 0 1 .301.684V26.2a1.88 1.88 0 0 1-.601 1.368 2.12 2.12 0 0 1-1.453.567H23.67a1.06 1.06 0 0 1-.727-.284.94.94 0 0 1-.3-.683.94.94 0 0 1 .3-.685 1.06 1.06 0 0 1 .727-.283h4.107v-1.935c0-.256.109-.503.301-.684.193-.182.454-.283.727-.283M5.964 5.842c-.525 0-1.03.204-1.402.568-.371.363-.58.857-.58 1.37V20.9a4 4 0 0 1 1.983-.52h.991V5.843zm22.84 8.749c.272 0 .533.101.725.283a.94.94 0 0 1 .301.683v3.87a.94.94 0 0 1-.3.684 1.06 1.06 0 0 1-.726.283 1.06 1.06 0 0 1-.727-.283.94.94 0 0 1-.3-.684v-3.87a.94.94 0 0 1 .3-.683 1.06 1.06 0 0 1 .727-.284m-1.028-7.74a2.12 2.12 0 0 1 1.453.567c.385.363.601.855.601 1.368v1.934a.94.94 0 0 1-.3.685 1.06 1.06 0 0 1-.726.283c-.273 0-.534-.102-.727-.283a.94.94 0 0 1-.3-.685V8.786h-4.108a1.06 1.06 0 0 1-.727-.283.94.94 0 0 1-.3-.685.94.94 0 0 1 .3-.684 1.06 1.06 0 0 1 .727-.283zm-8.587 0c.272 0 .534.102.726.283a.94.94 0 0 1 .3.684.94.94 0 0 1-.3.685 1.06 1.06 0 0 1-.726.283H15.08a1.06 1.06 0 0 1-.726-.283.94.94 0 0 1-.301-.685.94.94 0 0 1 .3-.684 1.06 1.06 0 0 1 .727-.283z"
    />
  </svg>
);
const SvgIconPlans = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconPlans);
export default Memo;
